import { render } from "./Calculator.vue?vue&type=template&id=5436ac1c"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"

import "./Calculator.vue?vue&type=style&index=0&id=5436ac1c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__